import { FSharpException, Union } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Types.js";
import { class_type, string_type, union_type } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Reflection.js";
import { defaultArgWith } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Option.js";

export class AuthenticationError extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["InvalidOrExpiredToken"];
    }
}

export function AuthenticationError_$reflection() {
    return union_type("Results.AuthenticationError", [], AuthenticationError, () => [[]]);
}

export function AuthenticationErrorModule_explain(_arg) {
    return "Session abgelaufen";
}

export class ServerError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Exception", "Authentication", "DatabaseItemNotFound"];
    }
}

export function ServerError_$reflection() {
    return union_type("Results.ServerError", [], ServerError, () => [[["Item", string_type]], [["Item", AuthenticationError_$reflection()]], [["Item", class_type("System.Guid")]]]);
}

export class ServerException extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function ServerException_$reflection() {
    return class_type("Results.ServerException", undefined, ServerException, class_type("System.Exception"));
}

export function ServerErrorModule_failwith(er) {
    throw new ServerException(er);
}

export function ServerErrorModule_ofOption(err, v) {
    return defaultArgWith(v, () => ServerErrorModule_failwith(err));
}

export function ServerErrorModule_ofResult(v) {
    if (v.tag === 1) {
        return ServerErrorModule_failwith(v.fields[0]);
    }
    else {
        return v.fields[0];
    }
}

//# sourceMappingURL=Errors.fs.js.map
